import React from "react";
import VideoEmbed from "../Global/VideoEmbed/VideoEmbed";
import BardCopy from "../Global/BardCopy/BardCopy";
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets";

const AltItem = ({data}) => {

    const imageAsset = data?.image;
    const image = imageAsset ? prefixStatamicAssetUrl(imageAsset.permalink || imageAsset.url) : null;
    const video = data?.video_url;
    const copy = data?.copy;
    const altText = imageAsset?.alt || 'Alt Row Image';
    let content = false;

    if (video) {
        content = (
        <div className="alt-video-container">
            <div className="alt-video-wrapper">
                <VideoEmbed url={video} />
            </div>
        </div>);
    } else if (image) {
        content = (
            <div className="image">
                <img src={image} alt={altText} />
            </div>
        );
    }

    return(
        <div className="alt-item">
            <div className="copy-container">
                <BardCopy nodes={copy} className="copy" />
            </div>
            {content && content}
        </div>
    );
}

export default AltItem;
